<template lang="pug">
div
  div.text-lg.font-medium.neutral700--text.mt-8 {{ $t('pre_appointment_instruction_optional') }}
  div.text-sm.neutral500--text {{ $t('pre_appointment_instruction_desc') }}

  v-row(no-gutters)
    v-col(cols="12" sm="6")
      div.text-md.font-medium.neutral700--text.mt-8 {{ $t('label_title_of_instruction') }}
      v-text-field.text-md.font-normal.mt-2.round-xl(v-model="label" :placeholder="$t('before_appointment')" outlined :rules="instructions ? rules.not_empty : []" dense height="48" hide-details="auto")

      div.text-md.font-medium.neutral700--text.mt-8 {{ $t('pre_appointment_instruction') }}
      v-textarea.text-md.font-normal.mt-2.round-xl(v-model="instructions" :placeholder="$t('pre_appointment_instruction_placeholder')" outlined :rules="label ? rules.not_empty : []" dense hide-details="auto")
  
  div.d-flex.mt-5
    v-spacer
    v-btn.round-lg.heading-6.px-8(v-if="service" color="neutral700" dark depressed height="48" :loading="isLoading" @click="saveData") {{ $t('save') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ServicePreInstructions',
  components: {  },
  inject: ['getRef'],
  data () {
    return {
      isLoading: false,
      label: null,
      instructions: null,
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        not_empty_select: [v => !!v || 'This field is required']
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      service: 'clinic/getService',
    }),
    instructionData () {
      if (!this.service) {
        return {
          pre_appointment: {
            label: this.label,
            instructions: this.instructions,
          }
        }
      }
      return null
    }
  },
  mounted () {
    if (this.service) {
      this.setData(this.service)
    } else {
      this.$watch('instructionData', {
        deep: true,
        handler (val) {
          this.$store.commit('clinic/updateTempService', val)
        } 
      })
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    setData (service) {
      if (service.instructions.pre_appointment) {
        this.label = service.instructions.pre_appointment.label
        this.instructions = service.instructions.pre_appointment.instructions
      }
    },
    saveData () {
      if (!this.getRef.form.validate()) {
        this.showMessage(['error', this.$t('error_message.please_fill_out_all')])
        return
      }
      this.isLoading = true
      let preAppointment = null
      if (this.label || this.instructions) {
        preAppointment = {
          label: this.label,
          instructions: this.instructions
        }
      }
      const data = {
        instructions: {
          pre_appointment: preAppointment,
          post_appointment: this.service.instructions.post_appointment
        }
      }
      const endpoint = `/clinics/${this.company.slug}/services/${this.service.id}`
      this.$axios.patch(endpoint, data)
        .then(resp => {
          this.updateActivityLog(endpoint, data, resp, 'PATCH', this.service.id)
          this.$store.commit('clinic/setService', resp.data)
          this.showMessage(['success', this.$t('success_message.update_successful')])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    updateActivityLog (endpoint, payload, response, method, id) {
      let data = {
        company: this.company.id,
        object_id: id || null,
        object_ref: 'service',
        activity: 'Update service (pre-appointment instruction)',
        raw_data: { endpoint, payload, response: response.data, method}
      }
      this.$axios.post('/users/logs', data)
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.file-change-layout {
  position: relative;
}
.input-change-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-basic500);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
.inputNumber >>> input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
.inputText >>> input {
  margin-top: 3px;
  text-align: center;
}
</style>